<template>
  <div class="modal fade" :id="option.id" role="dialog">
    <div class="modal-dialog choose-modal">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title text-left">{{option.title}}</h4>
        </div>
        <div class="modal-body text-left">
          <div
            class="text-left"
            v-for="adjust in adjustList"
            :key="adjust.item_id"
            v-if="adjust.active"
          >
            <h5 class="p-l-10">{{adjust.name}}&nbsp;&nbsp;
              $&nbsp;
              <price-input :item="adjust" @trigger="trigger" :id="adjust.adjust_id"></price-input>
            </h5>
            <div
              class="btn-money-element"
              v-for="option in adjust.child_list"
              :key="option.item_id"
              v-if="option.active"
              style="font-size: 14px"
            >
              {{option.name}}
              <div class="m-t-5">
                $&nbsp;
                <price-input :item="option" @trigger="trigger" :id="option.option_id" :class="{disabled: adjust.price}"></price-input>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" v-if="!hideCancel">取消</button>
          <button class="btn btn-primary" data-dismiss="modal">
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import priceInput from '../views/Menu/Temp/PriceInput.vue'
export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    adjustList: Array,
    hideCancel: Boolean
  },
  data () {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: ''
    }
  },
  components: {
    'price-input': priceInput
  },
  methods: {
    showRemark (elem) {
      this.elementRemark = elem.remark
    },
    hideRemark () {
      this.elementRemark = ''
    },
    trigger (event) {
      if (event === 'changePrice') {

      }
    },
    clickElement (option, adjust) {
      option.active = !option.active
    },
    clearAll () {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false
      }
    }
  }
}
</script>
<style lang="sass">
.btn-money-element
  margin: 8px
  padding: 10px
  width: calc(20% - 16px)
  background: #f4f4f4
  color: #444
  border: 1px solid #ddd
  display: inline-block
  font-weight: 500
  text-align: center
</style>



// WEBPACK FOOTER //
// ChooseMoneyModal.vue?7119b40d